export enum GoalStatus {
  OnTrack,
  Behind,
  Completed
}
